// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => ({"57":"index","96":"vendors"}[chunkId] + ".fonts.css");